import { Collapse } from 'antd';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function R() {
    const { useLang, Link, useRouter } = useGlobal();
    const { t } = useLang('costsaving-new');
    const { locale } = useRouter();
    let lists: any = [
        {
            title: t('secH_q1'),
            desc: t('secH_a1'),
        },
        {
            title: t('secH_q2'),
            desc: t('secH_a2'),
        },
        {
            title: t('secH_q3'),
            desc: t('secH_a3'),
        },
        {
            title: t('secH_q4'),
            desc: t('secH_a4'),
        },
        {
            title: t('secH_q5'),
            desc: t('secH_a5'),
        },
        {
            title: t('secH_q6'),
            desc: t('secH_a6'),
        },
        { title: t('secH_q7'), desc: t('secH_a7') },
        { title: t('secH_q8'), desc: t('secH_a8') },
    ];

    return (
        <div
            id="cost-saving-H"
            className={`cost-saving-H ${css['cost-saving-H']}${locale === 'au' ? ' is-au' : ''} GtmModuleData-section`}
            data-section-id={'cost-saving-H'}
            data-section-title={t('secH_title')}
        >
            <div className="text-info">
                <h2 className="title">{t('secH_title')}</h2>
            </div>
            <Collapse
                ghost={true}
                className="collapse-lists"
                defaultActiveKey={0}
                // onChange={setActive}
                // accordion={true}
                expandIcon={({ isActive }: any) => {
                    return (
                        <svg
                            className={`collapse-icon ${isActive ? 'active' : ''}`}
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                        >
                            <path d="M17.5 15L12.5 10L7.5 15" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    );
                }}
                expandIconPosition="right"
            >
                {lists?.map((list: any, k: number) => (
                    <Collapse.Panel className="list-title" key={k} header={list.title}>
                        <p className="list-desc">{list.desc}</p>
                    </Collapse.Panel>
                ))}
            </Collapse>
        </div>
    );
}
